import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import spreadsheetValidations from './spreadsheetValidations'

export class CheckAvailableModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    let invalid = this.props.grid
    // for (let i = 0; i < invalid.length; i++) {
    //   invalid[i][5].isValid = false
    //   let dateIsExceeded =
    //     new Date(invalid[i][5].value.match('^\\d{2}/\\d{2}/\\d{4}$')) >=
    //     moment(invalid[i][4].date).startOf('day')._d
    //   if (invalid[i][5].value !== '' && invalid[i][5].value !== 'Released Date')
    //     console.log(invalid[i][5].value.substring(3, 5))
    //   if (
    //     parseInt(
    //       `${new Date(
    //         invalid[i][5].value.match('^\\d{2}/\\d{2}/\\d{4}$')
    //       )}`.substring(7, 10)
    //     ) === parseInt(invalid[i][5].value.substring(3, 5)) &&
    //     dateIsExceeded
    //   ) {
    //     invalid[i][5].isValid = true
    //   }
    // }

    const invalidData = invalid.filter(crf =>
      spreadsheetValidations.releasedDate(crf[5].value)
    )

    const gridWithInput = this.props.grid.filter(
      crf => crf[5].value !== '' && crf[5].value !== 'Released Date'
    )

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Released</h4>
                        <h5 className='returnHeader'>
                          Are you sure you want to proceed? Please confirm.
                        </h5>
                      </>
                    ) : (
                      <h4>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[1].value}</span>
                    </div>

                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          crf[5].value === '' ||
                          isNaN(
                            new Date(
                              crf[5].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                            )
                          ) ||
                          !crf[5].value.match('^\\d{2}/\\d{2}/\\d{4}$') ||
                          crf[5].isValid === false
                            ? textRed
                            : null
                        }
                      >
                        Released Date:
                        {crf[5].value === '' ? 'Empty' : null}
                        {crf[5].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                          ? !isNaN(
                              new Date(
                                crf[5].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                              )
                            )
                            ? crf[5].isValid === true
                              ? crf[5].value
                              : 'Invalid'
                            : 'Invalid'
                          : crf[5].value !== ''
                          ? 'Invalid'
                          : null}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Date must be valid and in mm/dd/yyyy format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckReleased}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default CheckAvailableModal
